import { Expose } from 'class-transformer';

export class ParticipantListModel {
  id: string;
  schedule: string;

  @Expose({ name: 'titled_name' })
  titledName: string;

  @Expose({ name: 'bed_type' })
  bedType: string;

  @Expose({ name: 'group_number' })
  groupNumber: string;
}

export class getParticipantInput {
  id: string;
  params: {
    page: number;
    limit?: number;
    q?: string;
  };
}
